import $ from 'jquery';

import BaseVisualControlFactory from 'BaseVisualControlFactory.js';
import constants        from 'Constants.js';
import sequenceService  from 'SequenceService.js';

import ControlModel    from 'ControlModel.js';
import MovieControlView  from 'advanced-visuals/MovieControlView.js';



class ControlMovieFactory extends BaseVisualControlFactory {

    constructor () {
        super();
    }

    createView( factoryKey, pos ) {

        const attributes = this.createChildAttributes( factoryKey, pos ) ;

        //adding silent(accessibility) to attributes.
        attributes.silent = false;
        attributes.maintainAspectRatio = 'false';
        attributes.autoPlay = 'false';
        attributes.loop = '';
        attributes.volume = 25;
        attributes.resizePadding = 2;
		attributes.minWidth = 10;
		attributes.minHeight = 10;

        const view = new MovieControlView( { model: new ControlModel( attributes ),  el: $(constants.FORM_ID),
            pos: pos, factoryKey: factoryKey, id: attributes.id} );

        return view;
    }

}

const controlMovieFactory = new ControlMovieFactory();

export default controlMovieFactory;
